export class CharacterController {

    constructor() {
    }
}